<template>
  <div>
      <h4
        class="has-text-weight-bold is-size-6 has-padding-bottom-1"
        v-if="!noTitle">Datei hochladen</h4>
      <form class="form" action="POST" :id="'form-' + uniqueId">
        <label :for="uniqueId" class="label" :class="(isSmall) ? 'label--is-small' : ''">
            <div class="background">
                <span v-show="buttonText && !loading" :class="(isSmall) ? 'is-size-7 has-text-weight-bold' : ''" class="has-padding-left-0-5 has-padding-right-0-5">{{buttonText}}</span><i v-show="!loading" class="fa fa-upload is-size-4 has-padding-left-0 has-padding-right-0-5" :class="(isSmall) ? 'is-size-7 has-text-weight-bold' : ''"></i>
                <div class="button is-primary is-loading" v-show="loading"></div>
            </div>
        </label>
        <input @change="uploadFile" class="input is-sr" type="file" name="file-upload" :id="uniqueId">
    </form>
  </div>
</template>

<script>
export default {
    props: ['folderid', 'noTitle', 'buttonText', 'isSmall'],
    data() {
        return {
            loading: false,
            uniqueId: null
        }
    },
    mounted: function() {
        this.$nextTick(function () {
           return this.$data.uniqueId = 'file-upload-' + Math.floor(Math.random() * Math.floor(9999))
        })
    },
    methods: {
        uploadFile() {
          let data = new FormData();
          this.loading = true;
          let input = document.getElementById(this.$data.uniqueId)
          data.append('file', input.files[0]);

          axios.post(`/files/new/${this.folderid}`, data).then(res => {
              this.loading = false;
              return console.log(res)
          }).then(_ => {
              document.getElementById('form-'+this.$data.uniqueId).reset()
              location.reload(true)
          }).catch(e => {
              this.loading = false;
          });
        }
    }

}
</script>

<style scoped>
    .label {
        width: 100%;
        max-width: 360px;
        min-height: 36px;
        position: relative;
        display: flex;
        flex-direction: column;
        background-color: rgba(60, 57, 80, 1);
    }

    .label.label--is-small {
        min-height: 26px;
    }

     input.input:focus + .label,
    .label:hover {
        box-shadow: 2px 4px 10px gray;
    }

    .label .background {
        display: flex;
        align-items: center;
        justify-content: center;
        flex: 1 0 100%;
        color: white;
    }
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/ckUploadFile.vue